export default "__VITE_ASSET__BXSh1f9O__"